// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardListHeadingStyles } from "@vanmeter/Overrides/Components/CardListHeading";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";
import IconPaginationArrowRight from "@vanmeter/XDL/Icons/IconPaginationArrowRight";

cardListHeadingStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

cardListHeadingStyles.title = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

cardListHeadingStyles.viewAllLink = {
    icon: {
        iconProps: {
            src: IconPaginationArrowRight,
            size: 12,
        },
        position: "right",
    },
};
